import {
  type ChallengeSummary,
  type SetComplexImmerStateAction,
} from '@/lib/types';
import { useContext } from 'react';
import PortfolioModeContext from '@/lib/contexts/PortfolioModeContext';
import PortfolioUserContext from '@/lib/contexts/PortfolioUserContext';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import usePolledSwrAsComplexState from '@/lib/api/usePolledSwrAsComplexState';
import dummyFunction from '@/lib/utils/dummyFunction';

const useNewlySharedChallenges = ():
  | [true, null, () => void]
  | [
      false,
      Record<number, ChallengeSummary>,
      SetComplexImmerStateAction<Record<number, ChallengeSummary>>,
    ] => {
  const portfolioMode = useContext(PortfolioModeContext);
  const portfolioUser = useContext(PortfolioUserContext);

  const apiEndpoint =
    portfolioMode === PortfolioMode.COACH
      ? `challenge-portfolio/challenges/newly-shared/coach?userEmail=${portfolioUser!.email}`
      : 'challenge-portfolio/challenges/newly-shared';

  const [loading, newlySharedChallenges, setNewlySharedChallenges] =
    usePolledSwrAsComplexState<Record<number, ChallengeSummary>>(apiEndpoint);

  if (loading) {
    return [true, null, dummyFunction];
  }

  return [loading, newlySharedChallenges, setNewlySharedChallenges];
};

export default useNewlySharedChallenges;
